/**
 * Check if guests information form is enabled
 * @return {boolean}
 */
export const isGustsInformationRequired = () =>  {
    return $('#require-guests-details').val() === true;
}